<template>
	<div class="wrap1">
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党建共建</el-breadcrumb-item>
				<el-breadcrumb-item>党建带动</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="dyfcDetail">
						<div class="left_img">
							<img :src="img" >
						</div>
						<div class="right_words">
							<div class="detail_title">{{title}}</div>
							<div class="pub_time" style="margin-top: 10px;">时间：{{time}}</div>
						</div>
						<div class="contrl_bar1">
							<el-button type="primary" size="small" @click="goedit">编辑</el-button>
							<el-button type="primary" size="small"
							@click="$router.go(-1)">返回上级</el-button>
						</div>
					</div>
					<div class="content" style="margin: 20px 0;">
						<div>内容详情：</div>
						<div class="content_item" v-if="content!='暂无数据'" v-html="content"></div>
						<iframe class="content_item" style="min-height: 500px;" v-else :src="url"></iframe>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Detail from './mixins/detail.js'
	export default {
		mixins:[Detail]
	}
</script>

<style lang="scss">
	.wrap1{
		width: 100%;
		height: 100%;
		position: relative;
		color: $index_color;
		font-size: index_size1;
		.detail_title{
			font-size: 18px;
			margin-bottom: 10px;
			font-weight: bold;
		}
		.content{
			margin-top: 10px;
			.content_item{
				width: 70%;
				line-height: 40px;
				padding: 50px 50px;
				box-sizing: border-box;
				background: #FAFBFC;
				margin-top: 20px;
				border: 1px solid #DDE2EE;
				img{
					width: 100%;
					margin: 10px auto;
				}
			}
		}
		.dyfcDetail{
			display: flex;
			height: 180px;
			width: 100%;
			.left_img{
				width: 280px;
				height: 100%;
				background: #DDDDDD;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.right_words{
				margin:0 20px;
				flex: 1;
			}
		}
	}
</style>
